import { Routes } from '@angular/router';

import { AuthGuard } from '@lib/auth';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/access/guest/guest.component').then(c => c.GuestComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/login/login.component').then(c => c.LoginComponent),
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '',
    loadComponent: () => import('./pages/access/authorized/authorized.component').then(c => c.AuthorizedComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'protocols',
      },
      {
        path: 'dictionaries',
        loadComponent: () => import('./pages/dictionaries/dictionaries-list/dictionaries-list.component').then(c => c.DictionariesListComponent),
      },
      {
        path: 'dictionaries/:dictionaryId/edit',
        loadComponent: () => import('./pages/dictionaries/dictionary-edit/dictionary-edit.component').then(c => c.DictionaryEditComponent),
      },
      {
        path: 'protocols',
        loadComponent: () => import('./pages/protocols/protocols-list/protocols-list.component').then(c => c.ProtocolsListComponent),
      },
      {
        path: 'protocols/create',
        loadComponent: () => import('./pages/protocols/protocol-edit/protocol-edit.component').then(c => c.ProtocolEditComponent),
      },
      {
        path: 'protocols/:protocolId/edit',
        loadComponent: () => import('./pages/protocols/protocol-edit/protocol-edit.component').then(c => c.ProtocolEditComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
